import * as Sentry from "@sentry/react"
import { Routes } from "react-router-dom"

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
   // Optionally pass options listed below
})

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)
export { sentryReduxEnhancer, SentryRoutes }
